import React from 'react';

const VMK_TEAL = '#179f9f';

const iconProps = {
  className: 'vmk-sustainability-card-icon',
  width: 36,
  height: 36,
  viewBox: '0 0 36 36',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
};

const s = {
  stroke: VMK_TEAL,
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const VmkSustainabilityEnergyIcon = () => (
  <svg {...iconProps}>
    <path
      d="M18 5.5C12.5 12.5 9 16.5 9 22.5a9 9 0 1 0 18 0c0-6-3.5-10-9-17z"
      {...s}
    />
    <path d="M15 21.5c1.5-2.5 4-3 6.5-1.5" {...s} />
    <path d="M16.5 19l-1.5 2.5M18.5 17.5l1 2" {...s} />
  </svg>
);

export const VmkSustainabilityMaterialsIcon = () => (
  <svg {...iconProps}>
    <circle cx="18" cy="18" r="10" {...s} />
    <path d="M18 8v4M18 24v4M8 18h4M24 18h4" {...s} />
    <path d="M11.5 11.5l2.8 2.8M21.7 21.7l2.8 2.8M24.5 11.5l-2.8 2.8M14.3 21.7l-2.8 2.8" {...s} />
    <circle cx="18" cy="18" r="2.5" {...s} />
  </svg>
);

export const VmkSustainabilityValueIcon = () => (
  <svg {...iconProps}>
    <path d="M7 16.5 18 8l11 8.5V27a1.5 1.5 0 0 1-1.5 1.5H8.5A1.5 1.5 0 0 1 7 27V16.5z" {...s} />
    <path d="M14 28.5v-7h8v7" {...s} />
    <path d="M15 19.5h6" {...s} />
  </svg>
);

export const VMK_SUSTAINABILITY_ICONS = [
  VmkSustainabilityEnergyIcon,
  VmkSustainabilityMaterialsIcon,
  VmkSustainabilityValueIcon,
];
